import { Button, DatePicker, Modal, Select, Space } from "antd";
import { useState } from "react";
import locale from "antd/es/date-picker/locale/pt_BR";
import { api } from "../../config";
import { useSelector } from "react-redux";
import { AuthenticationState } from "../../interfaces/users";
import { toast } from "react-toastify";
import { format } from "date-fns";
import { Dayjs } from "dayjs";
import { SearchAssemblers } from "../Shared/Components/SearchAssemblers/SearchAssemblers";
import { formatCurrency } from "../../utils/helpers/ticketHelpers";
import { FieldReportViewModel } from "../../interfaces";

interface AssemblerPaymentModalProps {
  isOpen: boolean;
  onClose: () => void;
}
enum PaymentAdditionStatus {
  PENDING_APPROVEMENT,
  APPROVED,
  REJECTED,
}

export type TableItem = { id: number; description: string; value: number, status: string, externalId: number };
export type Addition = {
  id: number;
  typeId: number;
  description: string;
  value: number;
  fieldReportId: number;
  createdAt: string;
  updatedAt: string;
  status: PaymentAdditionStatus;
  fieldReport: FieldReportViewModel;
};


export const AssemblerPaymentModal = ({ isOpen, onClose }: AssemblerPaymentModalProps) => {
  const { token } = useSelector((state: AuthenticationState) => state);
  const [assembler, setAssembler] = useState<number | undefined>();
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState<
    | undefined
    | {
        [key: string]: {
          [key: string]: { items: TableItem[]; additions: Addition[] };
        };
      }
  >()
  const [expanded, setExpanded] = useState<string[]>([]);



  const handleClose = () => {
    setData(undefined)
    onClose();
  };

  const handleGenerate = async () => {
    if (!assembler) return toast.error("Selecione o Montador corretamente");
    try {
      setLoading(true)
        const result = await api(token).get(`/tickets/stats/?ownerId=${assembler}`)
        console.log(result)
        setData(result)
    } catch (error) {
      toast.error("Ocorreu um erro ao gerar o relatório");
    } finally {
      setLoading(false)
    }
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      onCancel={handleClose}
      footer={() => (
        <Button
          loading={loading}
          onClick={handleGenerate}
          variant="solid"
          color="primary"
        >
          Gerar
        </Button>
      )}
    >
      <p>Montador:</p>
      <SearchAssemblers
        setAssembler={setAssembler}
        assembler={assembler}
        disabled={false}
        onSearch={() => console.log("test")}
      />

      <Space />

      <div style={{ overflowY: "auto" }}>
        {!!data &&
          Object.entries(data).map(([key, item]) => (
            <div key={`main-${key}`} style={{ margin: "35px 0" }}>
              {Object.entries(item).map(([innerKey, items]) => (
                <div key={innerKey} style={styles.row}>
                  <span style={styles.label} title={getTitle(innerKey)}>
                    {getTitle(innerKey)}
                  </span>

                  <span
                    style={styles.value}
                    title={formatCurrency(
                      totalValue(items.items, items.additions)
                    )}
                  >
                    {formatCurrency(totalValue(items.items, items.additions))}
                  </span>
                </div>
              ))}

              <div style={styles.totalCard}>
                <div style={styles.totalRow}>
                  <span style={styles.totalLabel}>Pagamento previsto:</span>

                  <span style={styles.totalValue}>
                    {getPredictedValue(item)}
                  </span>
                </div>

                <div style={styles.totalRow}>
                  <span style={styles.totalLabel}>
                    Total Aprovado para {key}:
                  </span>

                  <span style={styles.totalValue}>
                    {getApprovedValue(item)}
                  </span>
                </div>

                <button
                  type="button"
                  onClick={() =>
                    setExpanded((ex) =>
                      ex.includes(key)
                        ? ex.filter((e) => e !== key)
                        : [...ex, key]
                    )
                  }
                  style={{
                    ...styles.totalRow,
                    background: "none",
                    border: "none",
                    width: "100%",
                    cursor: "pointer",
                    padding: "17px",
                    textAlign: "left",
                    height: "50px",
                  }}
                >
                  <span style={styles.totalLabel}>
                    {expanded.includes(key)
                      ? "Esconder OS"
                      : "Mostrar Todas OS do Período"}
                  </span>

                  <span style={styles.totalValue}>
                    {expanded.includes(key) ? "▲" : "▼"}
                  </span>
                </button>

                {expanded.includes(key) && (
                  <div style={styles.expandedContent}>
                    {getAllTickets(item).map((ticket) => (
                      <div key={ticket.id} style={styles.row}>
                        <span
                          style={styles.label}
                          title={
                            ticket.externalId
                              ? `O.S. ${ticket.externalId}`
                              : `S.A. ${ticket.id}`
                          }
                        >
                          <a
                            href={`/montagem?id=${ticket.id}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {ticket.externalId
                              ? `O.S. ${ticket.externalId}`
                              : `S.A. ${ticket.id}`}
                          </a>
                        </span>

                        <span style={styles.value}>
                          {formatCurrency(
                            totalValue(
                              [ticket],
                              getFieldReportAdditions(
                                item[ticket.status].additions,
                                ticket.id
                              )
                            )
                          )}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
      </div>
    </Modal>
  );
};

export const getFieldReportAdditions = (additions: any[], fieldReportId: number) => {
  const foundAdditions = additions.filter(add => add.fieldReportId === fieldReportId)
  return foundAdditions
}

export const totalValue = (items: any[], additions: any[]) => {
   return  (items?.reduce((acc, current) => (acc += current.value ?? 0), 0) ?? 0) +
    (additions?.reduce((acc, current) => (acc += current.value ?? 0), 0) ?? 0)
  }
  
export const getTotalValue = (items:  {[key:string] :{ items: any[]; additions: any[] }}) => {
  let total = 0
  for (const subItems of Object.values(items)) {
    total += totalValue(subItems.items, subItems.additions)
  }

  return formatCurrency(total)
}
export const getTitle = (key: string) => {
  const dict = {
    "ASSEMBLE_PENDING": "Aguardando Montagem",
    "ASSEMBLE_WAITING_ANALYSIS": "Aguardando Análise",
    "ASSEMBLE_APPROVED": "Montagem Aprovada",
    "ASSEMBLE_PAYMENT_APPROVED": "Pagamento Aprovado",
    "ASSEMBLE_FINALIZED": "Finalizado",
  }

  return dict[key as keyof typeof dict] ?? key
}

export const getPredictedValue = (items:  {[key:string] :{ items: TableItem[]; additions: Addition[] }} ) => {
    let total = 0
  for (const [key, subItems] of Object.entries(items)) {
    if (!['ASSEMBLE_PENDING', "ASSEMBLE_WAITING_ANALYSIS" ].includes(key) )

    total += totalValue(subItems.items, subItems.additions)
  }

  return formatCurrency(total)
}
export const getApprovedValue = (items:  {[key:string] :{ items: TableItem[]; additions: Addition[] }} ) => {
    let total = 0
  for (const [key, subItems] of Object.entries(items)) {
    if (['ASSEMBLE_PAYMENT_APPROVED', "ASSEMBLE_FINALIZED" ].includes(key) )

    total += totalValue(subItems.items, subItems.additions)
  }

  return formatCurrency(total)
}

export const getAllTickets = (period:  {[key:string] :{ items: TableItem[]; additions: Addition[] }} ) => Object.values(period).reduce((acc: TableItem[], current ) => acc = [...acc, ...current.items], [])

const styles: {
  row: React.CSSProperties;
  label: React.CSSProperties;
  value: React.CSSProperties;
  totalCard: React.CSSProperties;
  totalRow: React.CSSProperties;
  totalLabel: React.CSSProperties;
  totalValue: React.CSSProperties;
  expandedContent: React.CSSProperties;
  expandedText: React.CSSProperties;
}  = {
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "12px",
    borderRadius: "12px",
    backgroundColor: "#FFFFFF",
    border: "1px solid #E6EAF0",
    marginBottom: "8px",
  },

  label: {
    flex: 1,
    fontSize: "14px",
    color: "#0F172A",
    fontWeight: 600,
    paddingRight: "12px",
    borderRight: "1px solid #EEF2F7",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },

  value: {
    minWidth: "92px",
    marginLeft: "12px",
    fontSize: "14px",
    color: "#0F172A",
    fontWeight: 700,
    textAlign: "right",
    fontVariantNumeric: "tabular-nums",
    whiteSpace: "nowrap",
  },

  totalCard: {
    marginTop: "12px",
    borderRadius: "16px",
    border: "1px solid #E6EAF0",
    backgroundColor: "#FFFFFF",
    overflow: "hidden",
  },

  totalRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "14px 12px",
    borderBottom: "1px solid #EEF2F7",
  },

  totalLabel: {
    flex: 1,
    fontSize: "14px",
    fontWeight: 700,
    color: "#0F172A",
    borderRight: "1px solid #EEF2F7",
    paddingRight: "12px",
    textAlign: "left",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    height: "20px"
  },

  totalValue: {
    minWidth: "90px",
    marginLeft: "12px",
    fontSize: "16px",
    fontWeight: 700,
    color: "#0F172A",
    textAlign: "right",
    whiteSpace: "nowrap",
    fontVariantNumeric: "tabular-nums",
  },

  expandedContent: {
    padding: "12px",
    backgroundColor: "#F8FAFC",
  },

  expandedText: {
    fontSize: "14px",
    color: "#475569",
  },
};